import { type IBucket, IBucketID } from '@bridebook/models/source/models/Countries/Buckets.types';
import { PremiumTiers } from '@bridebook/toolbox/src/constants';

const result: IBucket = {
  id: IBucketID.FUTURE,
  settings: {
    automaticDowngradeTier: null,
    weddingFairs: null,
    templatedResponses: {
      venue: {
        [PremiumTiers.Unverified]: 1,
        [PremiumTiers.Tier_0]: 1,
        [PremiumTiers.Tier_0_5]: 1,
        [PremiumTiers.Tier_1]: 1,
        [PremiumTiers.Tier_2]: 1,
        [PremiumTiers.Tier_2_5]: 1,
        [PremiumTiers.Tier_3]: 1,
        [PremiumTiers.Tier_4]: 1,
      },
      suppliers: {
        [PremiumTiers.Tier_0]: 1,
        [PremiumTiers.Tier_1]: 2,
        [PremiumTiers.Tier_2]: 4,
      },
    },
    autoFollowUpTemplatedResponses: {
      venue: {
        [PremiumTiers.Tier_2_5]: 1,
        [PremiumTiers.Tier_3]: 4,
        [PremiumTiers.Tier_4]: Infinity,
      },
      suppliers: {
        [PremiumTiers.Tier_1]: 2,
        [PremiumTiers.Tier_2]: 4,
      },
      tier: {
        minimum: PremiumTiers.Tier_1,
        minimumByType: {
          venue: PremiumTiers.Tier_2_5,
        },
      },
    },
    instagramIntegration: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      types: {
        included: ['suppliers'],
      },
    },
    realWeddings: {
      tier: {
        minimum: PremiumTiers.Tier_0,
        minimumByType: {
          venue: PremiumTiers.Tier_2_5,
        },
      },
      types: {
        included: ['venue', 'photo'],
      },
    },
    realWeddingsCarousel: null,
    trendingCarouselSuppliers: {
      tier: {
        minimum: PremiumTiers.Unverified,
        minimumByType: {
          photo: PremiumTiers.Tier_1,
        },
      },
      types: {
        included: ['venue', 'photo'],
      },
    },
    roiSummary: null,
    badges: {
      tier: {
        minimum: PremiumTiers.Unverified,
      },
      types: {
        included: ['venue', 'suppliers'],
      },
    },
    couplesIntel: null,
    lostLeadsStats: null,
    lostLeadTracking: null,
    yourCompetitors: null,
    topSpot: null,
    multiCounty: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      suppliers: {
        [PremiumTiers.Tier_2]: 2,
      },
    },
    venueTypeHero: null,
    couplesActivity: {
      tier: {
        minimum: PremiumTiers.Tier_1,
        minimumByType: {
          venue: PremiumTiers.Tier_0,
        },
      },
      types: {
        included: ['venue', 'suppliers'],
      },
    },
    revealCoupleEmailAddress: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['suppliers'],
      },
    },
    revealCouplePhoneNumber: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['suppliers'],
      },
    },
    lostLeadsInsightsEnquirySource: null,
    contactCouples: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      suppliers: {
        [PremiumTiers.Tier_2]: 4,
      },
    },
    coupleTargeting: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['suppliers'],
      },
    },
    coupleTargetingGuestCount: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['suppliers'],
      },
    },
    lateAvailability: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      suppliers: {
        [PremiumTiers.Tier_2]: 4,
      },
    },
    couplesInsightsSearchAppearances: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['photo'],
      },
    },
    couplesInsightsProfileViews: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['photo'],
      },
    },
    couplesInsightsEnquiries: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['photo'],
      },
    },
    deals: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      types: {
        included: ['suppliers'],
      },
    },
    searchOptimisation: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['photo'],
      },
    },
    bridebookDiscounts: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        excluded: ['group'],
      },
    },
    videoTours: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['suppliers'],
      },
    },
    professionalNetwork: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['suppliers'],
      },
    },
    specialOfferRecommendation: null,
    searchPerformance: {
      tier: {
        minimum: PremiumTiers.Unverified,
      },
      types: {
        included: ['suppliers'],
      },
    },
    socialMediaSupport: null,
    marketInsightsStats: null,
    marketInsightsStatsCoupleBudget: null,
    bridebookInstitute: null,
    upgradePlan: {
      tier: {
        minimum: PremiumTiers.Unverified,
      },
      types: {
        included: ['suppliers'],
      },
    },
    weddingReports: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['suppliers'],
      },
    },
    searchBoost: null,
    chargebeePricingTable: null,
    adminBanners: true,
    messageCenter: null,
    businessSelfSignUp: null,
    featureTutorials: null,
    aboutYou: {
      types: {
        included: ['suppliers'],
      },
    },
    countyDropdown: true,
    searchPresets: null,
    smartEmails: null,
    locations: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      types: {
        included: ['suppliers'],
      },
    },
    onboardingConciergeFlow: null,
    enquiryWidget: {
      types: {
        included: ['venue'],
      },
    },
    welcomeMessage: {
      types: {
        included: ['venue'],
      },
    },
    trends: null,
    historicalSearchPositionChart: null,
    keepRelationsOnTierDowngrade: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['suppliers'],
      },
    },
    replyToReviews: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      types: {
        included: ['suppliers'],
      },
    },
    inspirationAndAdvice: null,
    specialOffersCarousel: null,
    rapidResponder: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['suppliers'],
      },
    },
    featuredSupplierMarker: {
      tier: {
        minimum: PremiumTiers.Tier_1,
        minimumByType: {
          venue: PremiumTiers.Tier_2,
        },
      },
    },
    youMayAlsoLikeCarousel: {
      venue: [],
    },
    couplesAlsoLikeCarousel: {
      venue: [],
    },
    additionalImageOnSearch: null,
    quickFiltersPill: {
      venue: ['exclusiveUse', 'weddingLicence', 'hasLateAvailability'],
      photo: ['videographyAvailable'],
      music: ['dj', 'ensembleGroup', 'soloMusician'],
      catering: ['staffProvided', 'tablewareProvided'],
    },
    quickFiltersDropdown: {
      venue: ['guests', 'upcomingEvents', 'venueType', 'noOfBedrooms'],
      photo: ['photographyStyle'],
      music: ['musicStyle'],
      catering: ['foodType', 'dietaryOptions'],
    },
    recommendedSuppliersCarousel: null,
    recommendations: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
    hideLimitedProfiles: null,
    hasEssentials: null,
    smartPricing: null,
    mandatoryOnboardingPhoneNumber: null,
    freeTrial: null,
    profileHighlightsSection: {
      types: {
        included: ['venue', 'photo'],
      },
    },
    seoScoreBoost: {
      tiers: {
        [PremiumTiers.Tier_1]: 1,
        [PremiumTiers.Tier_2]: 2,
      },
      types: {
        excluded: ['venue'],
      },
    },
    searchFilters: {
      venue: {
        priceSection: ['hasQualityPricing'],
        guestsSection: true,
        distanceSection: true,
        upcomingEvents: ['hasShowroundViewingDatesAvailable', 'hasWeddingFairOrOpenDay'],
        accommodationRoomsSection: true,
        venueType: [
          'countryHouseManorHouse',
          'barn',
          'gardenOutdoor',
          'statelyHome',
          'castle',
          'hotel',
          'cityHotelCityVenue',
          'warehouseFactory',
          'museumAttraction',
          'uniqueVenueType',
          'pubRestaurant',
          'golfCourse',
          'cruiseBoatYacht',
          'sportingVenueStadium',
          'conferenceCentre',
          'placeOfWorship',
          'townHallRegistryOffice',
          'otherVenueType',
          'winery',
        ],
        venueStyle: [
          'classic',
          'intimate',
          'alternative',
          'romantic',
          'lovelyGrounds',
          'unusual',
          'affordable',
          'outdoor',
          'luxury',
          'rustic',
          'beach',
          'modern',
          'unique',
          'urban',
          'blankCanvas',
          'greatViews',
          'historic',
          'asian',
          'casual',
          'formal',
          'stylish',
        ],
        venueFeatures: [
          'onsiteParking',
          'disabledAccess',
          'inHouseWeddingCoordinator',
          'inHouseDancefloor',
          'soundSystemAvailable',
          'ballroom',
          'confettiPermitted',
          'fireworksPermitted',
          'marqueePermitted',
          'waterView',
          'landscapedGardens',
          'petFriendly',
          'churchWithinWalkingDistance',
          'transportation',
          'wifi',
        ],
        foodDrinkSection: [
          'inHouseCatering',
          'externalCateringPermitted',
          'kosherCatering',
          'halalCatering',
          'asianCatering',
          'byobPermitted',
          'vegan',
        ],
      },
    },
    forcedCuratedListSearch: null,
    upcomingShowroundsWidget: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
    brochureActivity: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      types: {
        included: ['venue'],
      },
    },
    multiShowrounds: true,
    aiWeddingPlanner: null,
  },
};

export default {
  [result.id]: result,
};
